import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { contains } from 'ramda';

import { apiGetGroups, apiRemoveUserGroup } from '../../../../../api/user';
import { handleSuccessBase, handleErrorBase } from '../../../../../util/forms';

import Card from '../../../../../components/Card';
import GroupModal from '../../../../../components/Modal/GroupModal';

class Groups extends Component {
  static propTypes = {
    user: PropTypes.object,
    updateUser: PropTypes.func,
  };

  state = {
    loaded: false,
    showModal: false,
    groups: [],
  };

  constructor(props) {
    super(props);

    apiGetGroups().then(({ data }) => this.setState({ loaded: true, groups: data }));
  }

  render() {
    const { user, updateUser } = this.props;
    const { loaded, groups, showModal } = this.state;
    if (!loaded) return <noscript />;

    const userGroupIds = user.groups.map((group) => group.id);

    return (
      <Fragment>
        <Card>
          <Card.Header>
            Groups
            <button onClick={() => this.setState({ showModal: true })} className="btn btn-sm btn-primary float-right">
              Add Groups
            </button>
          </Card.Header>
          <Card.Body>
            {user.groups.length == 0 ? (
              <p>This user does not belong to any groups</p>
            ) : (
              <table className="table">
                <thead>
                  <tr>
                    <th className="w-100">Name</th>
                    <th />
                  </tr>
                </thead>
                <tbody>
                  {user.groups.map((group) => (
                    <tr key={group.id}>
                      <td>{group.name}</td>
                      <td>
                        <button
                          className="btn btn-link"
                          onClick={() =>
                            apiRemoveUserGroup(user.id, group.id)
                              .then(({ data }) => updateUser({ ...user, groups: data }))
                              .then(() => handleSuccessBase())
                              .catch((err) => handleErrorBase('Could not remove group'))
                          }
                        >
                          Remove
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
          </Card.Body>
        </Card>
        <GroupModal
          show={showModal}
          user={user}
          groups={groups.filter((group) => !contains(group.id, userGroupIds))}
          onHide={() => this.setState({ showModal: false })}
          updateUserGroups={(groups) => updateUser({ ...user, groups })}
        />
      </Fragment>
    );
  }
}

export default Groups;
